
import { Tab } from "../../../stores/TabsStore";
import { Separator } from "../../../ui/Separator";

import { ReportViewButton } from "./ReportViewButton";

import { TemplateItem } from "./Templates/Item/Item";
import { TemplateSummary } from "./Templates/Summary/Summary";



interface Props {
  tab: Tab;
}

function ReportGraph({tab}: Props) {
  function renderReport(tab: Tab) {
    if(tab.view === "report" && tab.reportOptions.type && tab.reportOptions.items.length > 0) {
      switch (tab.reportOptions.type) {
        case "summary": return <TemplateSummary tab={tab}/>
        case "item": return <TemplateItem tab={tab}/>
        default:
          return <>report type not found</>
      }
    } else {
      return <>report not found</>
    }
  }

  return (
    <>
      <div className="flex flex-none h-12 w-full items-center px-2 gap-4 justify-between">
        <div className="flex gap-2 items-center">
          <ReportViewButton />
        </div>
      </div>
      <Separator />
      {renderReport(tab)}
    </>
  );
}

export default ReportGraph;



